"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.Wrapper = theme_1.styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;
